import React from 'react'

export function IconMinhasFichasComponent({ fill = '#7E7E7E', height = '17', width = '17' }: { fill?: string, height?: string, width?: string }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill={fill} viewBox="0 0 20 20">
      <path fill={fill} d="M18.333 3.333h-6.666L10 1.666H5c-.442 0-.866.176-1.179.488-.312.313-.488.737-.488 1.179v10c0 .442.176.866.488 1.178.313.313.737.488 1.179.488h13.333c.442 0 .866-.175 1.179-.488.312-.312.488-.736.488-1.178V4.999c0-.442-.176-.866-.488-1.178-.313-.313-.737-.488-1.179-.488zM1.667 4.999H0v11.667c0 .442.176.866.488 1.178.313.313.737.489 1.179.489h15v-1.667h-15V4.999z" />
    </svg>
  )
}
